import InputQuantity from './InputQuantity'

export default InputQuantity
